import { createContext, Dispatch, FormEvent, SetStateAction, useContext } from 'react';
import { Surgerie } from 'types/surgerie';
import { ReportSurgerieQueryParams } from './useFetchReportSurgeries';

export interface ReportSurgerieContextValue {
  anchorEl: HTMLButtonElement | null;
  setAnchorEl: Dispatch<SetStateAction<HTMLButtonElement | null>>;
  filter: ReportSurgerieQueryParams;
  handleChange<K extends keyof ReportSurgerieQueryParams>(index: K, value: ReportSurgerieQueryParams[K]): void;
  handleSearch(e?: FormEvent<HTMLFormElement>): void;
  loading: boolean;
  setSelectedSurgerie: Dispatch<SetStateAction<Surgerie | null>>;
  selectedSurgerie: Surgerie | null;
  surgeries: Surgerie[];
}

const ReportSurgerieContext = createContext<ReportSurgerieContextValue>({} as ReportSurgerieContextValue);
export const ReportSurgerieProvider = ReportSurgerieContext.Provider;
export const ReportSurgerieConsumer = ReportSurgerieContext.Consumer;

export function useReportSurgerie(): ReportSurgerieContextValue {
  const context = useContext(ReportSurgerieContext);
  return context;
}
